import { configureStore } from "@reduxjs/toolkit";
import otpAuthSlice from "../slices/otpAuthSlice";
import AlertMessageSlice from "../slices/AlertMessageSlice";
import OrderSlice from "../slices/order-processing-slices/OrderSlice";
import MagicSlice from "../slices/MagicSlice";
import CartSlice from "../slices/product-processing-slices/CartSlice";
import ProductProcessingSlice from "../slices/product-processing-slices/ProductProcessingSlice";
import AddressSlice from "../slices/user-processing-slices/AddressSlice";
import CustomDomainSlice from "../slices/customDomainSlice";
import EmailAuthSlice from "../slices/EmailAuthSlice";
import ProductReviewSlice from "../slices/product-processing-slices/ProductReviewSlice";
import WishlistSlice from "../slices/product-processing-slices/WishlistSlice";

export const store = configureStore({
  reducer: {
    auth: otpAuthSlice,
    notification: AlertMessageSlice,
    order: OrderSlice,
    magic: MagicSlice,
    cart: CartSlice,
    product: ProductProcessingSlice,
    address: AddressSlice,
    custom: CustomDomainSlice,
    emailAuth: EmailAuthSlice, // Importing EmailAuthSlice
    review: ProductReviewSlice,
    rate: ProductReviewSlice,
    wishlist: WishlistSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(),
});
